import { Controller } from 'stimulus';

/**
 * Show/hide vitals section when a resident is selected from the dropdown
 */
export default class extends Controller {
  static targets = ['vitalsSection'];

  connect() {
    this.toggleVitals();
  }

  toggleVitals() {
    const select = this.element.querySelector(
      'select[name="vip[ehr_resident_data]"]'
    );
    if (!select) return;

    const hasResident = select.value && select.value.length > 0;

    this.vitalsSectionTargets.forEach((section) => {
      section.style.display = 'none';
    });

    if (hasResident) {
      const selectedProvider = select.value.split('|')[0];
      const matchingSection = this.vitalsSectionTargets.find(
        (section) => section.dataset.provider === selectedProvider
      );

      if (matchingSection) {
        matchingSection.style.display = 'block';
      }
    }
  }
}
